import { render, staticRenderFns } from "./WonderYjjRateML.vue?vue&type=template&id=40d93d5e"
import script from "./WonderYjjRateML.vue?vue&type=script&lang=js"
export * from "./WonderYjjRateML.vue?vue&type=script&lang=js"
import style0 from "./WonderYjjRateML.vue?vue&type=style&index=0&id=40d93d5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports